import { AzmoonMaharatDetail_Interface } from "./AzmoonMaharatDetail_Interface";

export interface AzmoonMaharatRequest_Interface {
    id:number,
    confirmm:number,
    title:string,
    code:string,
    startDate:string,
    endDate:string,
    status:Array<AzmoonMaharatDetail_Interface>,
    child:Array<AzmoonMaharatDetail_Interface>,
    canSignIn:boolean,
    canSignInCount:number
  }
  
  export function Empty_AzmoonMaharatRequest_Interface():AzmoonMaharatRequest_Interface{
    return{
      id:0,
      confirmm:0,
      title:'',
      code:'',
      startDate:'',
      endDate:'',
      status:[],
      child:[],
      canSignIn:false,
      canSignInCount:0
    }
  }